import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { formatDateTime } from "@/lib/helpers";

// Parent Dashboard -> quick-action helper: choose which upcoming lesson to
// reschedule when there's more than one. Extracted from ParentDashboard.js
// (props-driven, no behavior change).
export const ChooseLessonRescheduleDialog = ({ open, onOpenChange, lessons, onPick }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="choose-lesson-reschedule-dialog">
      <DialogHeader>
        <DialogTitle>Which lesson would you like to reschedule?</DialogTitle>
      </DialogHeader>
      <div className="divide-y max-h-72 overflow-y-auto -mx-1 px-1">
        {lessons.map((appt) => (
          <button
            key={appt.id}
            onClick={() => onPick(appt)}
            className="w-full text-left py-2.5 hover:bg-accent transition-colors rounded-[var(--radius)] px-2"
            data-testid="choose-lesson-reschedule-row"
          >
            <p className="text-sm font-medium">{appt.student_name}</p>
            <p className="text-xs text-muted-foreground">{formatDateTime(appt.start_time)} &middot; {appt.instructor_name || "-"}</p>
          </button>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
